module.exports = __webpack_public_path__ + "static/media/loading-yellow.3f8827b9.svg";